<!--Management Layout-->
<div *ngIf="filteredScreens">
    <mat-nav-list class="side-navbar">
        <div *ngFor="let screen of filteredScreens; index as i;">
            <div [ngTemplateOutlet]="screen.children ?  childMenu : parentMenu"
                          [ngTemplateOutletContext]="{screen:screen}">
            </div>
        </div>
    </mat-nav-list>

    <ng-template #parentMenu let-screen="screen">
        <mat-list-item [routerLink]="screen.route" routerLinkActive="is-active" [routerLinkActiveOptions]="{exact:
        true}" (click)="onScreenSelected(screen)" mat-list-item [attr.data-testid]="screen.name" [ngStyle]="{'margin-left': '7px'}">
            {{ screen.name }}
        </mat-list-item>
    </ng-template>

    <ng-template #childMenu let-screen="screen">
        <mat-expansion-panel [class.mat-elevation-z0]="true" [expanded]="isPanelExpanded(screen)">
            <mat-expansion-panel-header>
                {{ screen.name }}
            </mat-expansion-panel-header>
            <mat-nav-list class="expandable">
                <mat-list-item [routerLink]="nestedScreen.route" *ngFor="let nestedScreen of screen.children"
                               routerLinkActive="is-active" [routerLinkActiveOptions]="{exact:true}"
                               (click)="onScreenSelected(nestedScreen)" mat-list-item [attr.data-testid]="screen.name">
                    {{ nestedScreen.name }}
                </mat-list-item>
            </mat-nav-list>
        </mat-expansion-panel>
    </ng-template>

</div>

<!--Reports Layout-->
<div *ngIf="!filteredScreens">
    <mat-nav-list>
        <mat-list-item
            *ngFor="let screen of screens"
            [attr.data-testid]="screen.name"
            mat-list-item
            [ngClass]="{ selected: screen.selected }"
            (click)="onScreenSelected(screen)"
            routerLinkActive="is-active"
        >
            {{ screen.name }}
        </mat-list-item>
    </mat-nav-list>
</div>
